<template>
    <v-layout>
        <div class="col-12">
            <v-alert v-if="mode === 'inprogress'" type="info" text class="ma-3">
                <span class="blue--text text--darken-2">{{ $t('redeem_limb_notice') }}</span>
            </v-alert>
            <v-data-table
                    mobile-breakpoint="980"
                    :headers="tableHeaders"
                    :items="items"
                    :server-items-length="totalItems"
                    :loading="loading"
                    :footer-props="footerProps"
                    :page="page"
                    :options.sync="options"
                    class="users-table"
            >
                <template v-slot:top>
                    <v-toolbar class="flex-columned-toolbar" height="auto" flat>
                        <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                            <v-text-field
                                    v-model="search"
                                    prepend-icon="mdi-magnify"
                                    :label="$t('search')"
                                    single-line
                                    hide-details
                                    clearable
                                    @keyup.enter.prevent="setSearch()"
                                    @click:clear="clearSearch()"
                            ></v-text-field>
                        </v-col>
                        <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                            <v-select
                                    hide-details
                                    v-model="filteredcompany"
                                    :items="allcompanies(companies)"
                                    :label="$t('company')"
                                    item-text="name"
                                    item-value="id"
                                    @change="selectCompany"
                            >
                            </v-select>
                        </v-col>
                        <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                            <v-select
                                    hide-details
                                    v-model="filteredDivision"
                                    :items="filteredDivisions"
                                    :label="$t('division')"
                                    item-text="name"
                                    item-value="id"
                                    @change="selectFilter"
                            ></v-select>
                        </v-col>
                        <v-col v-if="mode === 'all'" class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                            <v-select
                                    hide-details
                                    v-model="filteredStatus"
                                    :items="filteredStatuses"
                                    item-text="value"
                                    item-value="key"
                                    :label="$t('status')"
                                    @change="selectFilter"
                            ></v-select>
                        </v-col>
                    </v-toolbar>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.status="{ item }">
                    <v-chip :color="statusColor(item.status)" dark>
                        <strong>{{ statusLabel(item.status) }}</strong>
                    </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.actions="{ item }">
                    <div class="d-flex">
                        <v-icon class="mr-3 cursor-pointer" size="20" :title="$t('redeem')" @click="showConfirm(item)">
                            mdi-check-circle
                        </v-icon>
                        <v-icon class="cursor-pointer" size="20" :title="$t('cancel')" @click="showReject(item)">
                            mdi-cancel
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
            <Confirmationdialog
                    :visible="showConfirmDialog"
                    @confirmationdialog:cancelClick="cancelConfirm"
                    @confirmationdialog:confirmClick="confirmTransfer"
            >
                <template v-slot:cardText>{{$t('confirm_transfer_prompt')}}</template>
            </Confirmationdialog>
            <Confirmationdialog
                    :visible="showRejectDialog"
                    @confirmationdialog:cancelClick="cancelReject"
                    @confirmationdialog:confirmClick="rejectTransfer"
            >
                <template v-slot:cardText>{{$t('reject_transfer_prompt')}}</template>
            </Confirmationdialog>
        </div>
    </v-layout>
</template>
<script>

    import {apiCall} from "@/utils/api.js";
    import {mapActions} from "vuex";
    import Confirmationdialog from "@/components/ConfirmationDialog";

    export default {
        name: "RedeemLogTable",
        components: {
            Confirmationdialog,
        },
        props: {
            mode: {
                type: String,
                default: 'all',
            },
        },
        data(context) {
            return {
                footerProps: {
                    "items-per-page-options": [10, 20, 50],
                },
                totalItems: 0,
                items: [],
                companies: [],
                loading: true,
                options: {
                    sortBy: [],
                    sortDesc: [],
                },
                filteredcompany: 0,
                search: null,
                searchValue: null,
                page: 1,
                filteredDivision: 0,
                filteredStatus: 'all',
                filteredStatuses: [...this.getQueueStatuses(), {key: 'all', value: this.$t('all')}],
                filteredDivisions: [{id: 0, name: this.$t('all')}],
                selectedItem: null,
                showConfirmDialog: false,
                showRejectDialog: false,
                headers: [
                    {text: context.$t('employee_name'), value: "fullname", sortable: false},
                    {text: context.$t('employee_id'), align: "start", value: "employeeid", sortable: false},
                    {text: context.$t('email'), value: "email", sortable: false},
                    {text: context.$t('company'), value: "company", sortable: false},
                    {text: context.$t('amount'), value: "amount", sortable: false},
                    {text: context.$t('status'), value: "status", sortable: false},
                    {text: context.$t('redeem_result'), value: "errors", sortable: false},
                    {text: context.$t('date'), value: "date", sortable: false},
                    {text: context.$t('actions'), value: "actions", sortable: false},
                ],
            };
        },
        computed: {
            tableHeaders() {
                return this.mode === 'inprogress'
                    ? this.headers
                    : this.headers.filter(h => h.value !== 'actions');
            },
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi();
                },
                deep: true,
            },
        },
        mounted() {
            this.getCompanies();
        },
        methods: {
            ...mapActions("service", ["setSnackbar"]),
            getModeStatusKeys() {
                return this.mode === 'inprogress'
                    ? ['inprogress']
                    : ['success', 'error'];
            },
            statusLabel(status) {
                return status === 'InProgress' ? 'In progress' : status;
            },
            getQueueStatus(status) {
                return this.$t(`queueStatuses.${status}`);
            },
            getQueueStatuses() {
                return this.getModeStatusKeys().map(key => {
                    return {"key": key, value: this.getQueueStatus(key)};
                });
            },
            statusColor(status) {
                switch (status) {
                    case "Success":
                        return "#70ad47";
                    case "InProgress":
                        return "#1976d2";
                    case "Error":
                    case "Cancelled":
                        return "#f00";
                    default:
                        return "transparent";
                }
            },
            clearSearch() {
                this.search = null;
                this.searchValue = this.search;
                this.$nextTick(() => {
                    this.options = {...this.options, page: 1};
                });
            },
            setSearch() {
                this.searchValue = this.search;
                this.options = {...this.options, page: 1};
            },
            allcompanies(companies) {
                return [{id: 0, name: this.$t('all')}, ...companies];
            },
            async selectCompany() {
                await this.getFilteredDivisions();
                this.options = {...this.options, page: 1};
            },
            selectFilter() {
                this.options = {...this.options, page: 1};
            },
            getCompanies() {
                apiCall("get", "companies/get", true).then((response) => {
                    this.companies = response.data;
                });
            },
            async getFilteredDivisions() {
                this.filteredDivision = 0;
                apiCall("get", `divisions/get?companyid=${this.filteredcompany}`, true).then((response) => {
                    this.filteredDivisions = [{id: 0, name: this.$t('all')}, ...response.data];
                });
            },
            getDataFromApi() {
                this.loading = true;

                const modeStatuses = this.getModeStatusKeys();
                const statuses = (this.mode === 'all' && this.filteredStatus !== 'all')
                    ? [this.filteredStatus]
                    : modeStatuses;

                const params = {
                    page: this.options.page - 1,
                    sortDirection: "desc",
                    sortField: "id",
                    perpage: this.options.itemsPerPage,
                    companyid: this.filteredcompany,
                    divisionid: this.filteredDivision,
                    search: this.searchValue,
                    statuses: statuses.join(','),
                };

                apiCall("get", "users/redeemlogs", {params: params}, true).then((response) => {
                    this.items = response.data.content;
                    this.totalItems = response.data.totalElements;
                    this.loading = false;
                });
            },
            showConfirm(item) {
                this.selectedItem = item;
                this.showConfirmDialog = true;
            },
            cancelConfirm() {
                this.showConfirmDialog = false;
                this.selectedItem = null;
            },
            confirmTransfer() {
                const params = {id: this.selectedItem.id};
                apiCall("post", `users/redeemlog/confirm`, {data: params}, true).then((response) => {
                    this.setSnackbar({
                        color: response.data.status == true ? "success" : "error",
                        text: response.data.result,
                        toggle: true,
                    });
                }).catch(e => {
                    this.setSnackbar({
                        color: "error",
                        text: e?.data?.result || this.$t('unknown_error'),
                        toggle: true,
                    });
                }).finally(() => {
                    this.getDataFromApi();
                    this.showConfirmDialog = false;
                    this.selectedItem = null;
                });
            },
            showReject(item) {
                this.selectedItem = item;
                this.showRejectDialog = true;
            },
            cancelReject() {
                this.showRejectDialog = false;
                this.selectedItem = null;
            },
            rejectTransfer() {
                const params = {id: this.selectedItem.id};
                apiCall("post", `users/redeemlog/reject`, {data: params}, true).then((response) => {
                    this.setSnackbar({
                        color: response.data.status == true ? "success" : "error",
                        text: response.data.result,
                        toggle: true,
                    });
                }).catch(e => {
                    this.setSnackbar({
                        color: "error",
                        text: e?.data?.result || this.$t('unknown_error'),
                        toggle: true,
                    });
                }).finally(() => {
                    this.getDataFromApi();
                    this.showRejectDialog = false;
                    this.selectedItem = null;
                });
            },
        },
    };
</script>
<style scoped>

    @media (max-width: 480px) {
        .users-table /deep/ .v-data-footer {
            justify-content: center;
            padding-bottom: 8px;
        }

        .users-table /deep/ .v-data-footer__pagination {
            display: none;
        }

        .users-table /deep/ .v-data-table__mobile-row__cell {
            overflow-wrap: anywhere;
        }
    }

    @media (max-width: 1280px) {
        .flex-columned-toolbar >>> .v-toolbar__content {
            flex-wrap: wrap;
            justify-content: right;
        }
    }
</style>
